module.exports = __webpack_public_path__ + "img/ic_info.45739445.svg";